import { render, staticRenderFns } from "./TermsConditionsModal.component.vue?vue&type=template&id=2fbd1570&scoped=true"
import script from "./TermsConditionsModal.component.vue?vue&type=script&lang=js"
export * from "./TermsConditionsModal.component.vue?vue&type=script&lang=js"
import style0 from "./TermsConditionsModal.component.vue?vue&type=style&index=0&id=2fbd1570&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fbd1570",
  null
  
)

export default component.exports